const loadDefault = function (vm, callback) {
    vm.$ajax({
        url: "/api/document/currency/getStandard",
        async: false,
        resolve(res) {
            if (res.success) {
                callback(res.data);
            } else {
                vm.$weui.topTips(res.message, 2000);
            }
        }
    });
}, loadAll = function (vm) {
    return vm.$loading({
        url: "/api/document/currency/list",
        params: {
            number: 1,
            size: 100
        }
    }).then(function (res) {
        if (res.success) {
            return res.data;
        } else {
            vm.$weui.topTips(res.message, 2000);
        }
    });
};

/**
 * 币种筛选
 */
export default {
    init(filter, vm) {
        loadDefault(vm, function (data) {
            filter.value = data.cr_name;
        });
    },
    handler(filter, vm) {
        loadAll(vm).then(function (data) {
            var options = data.list.map(o => {
                return Object.assign(o, {
                    label: o.cr_name,
                    value: o.cr_name
                });
            });
            vm.$weui.picker(options, {
                defaultValue: [filter.value],
                onConfirm: function (result) {
                    if (result.length) {
                        filter.value = result[0].value;
                        vm.onChange(filter);
                    }
                }
            });
        });
    },
    renderer(filter) {
        return filter.value;
    },
    fn(value, filter) {
        return {
            type: "enum",
            field: filter.name,
            operation: "in",
            value: "'" + value + "'"
        };
    }
}